import PropTypes from 'prop-types';
import React from 'react';
import { localStore } from 'helpers';
import { withRouter } from 'react-router';

const withCurrentUser = Component => {
  const Container = props => {
    // console.log(`With Current User Called...`);
    // let user = localStore.getItem('user') || null;
    // if (global.currentUser) {
    //   user = JSON.stringify(global.currentUser);
    // }
    // if (user) {
    //   try {
    //     user = JSON.parse(user);
    //   } catch (e) {
    //     console.log(e);
    //   }
    // }
    let user = {};
    const updatedProps = {
      ...props,
      currentUser: user
    };
    global.currentUser = user;
    console.log(`user --`, user);
    return <Component {...updatedProps} />;
  };

  Container.propTypes = {
    currentUserQuery: PropTypes.object
  };

  return Container;
};

export default withRouter(withCurrentUser);



// WEBPACK FOOTER //
// ./src/modules/auth/containers/withCurrentUser.js